import extend from 'quasar/src/utils/extend/extend.js';
import { MsgBox } from "~/components/MsgBox";
export class PagingListHelper {
    constructor(option, log, isShowRecordsByInitialize = true) {
        this.log = log;
        this.isShowRecordsByInitialize = isShowRecordsByInitialize;
        this.mode = option.mode;
        if (option.mode === "store") {
            this.store = option.store;
            if (!this.store.isInitialized) {
                this.store.init();
            }
        }
        else {
            this.list = option.list;
            this.loadFn = option.load;
            this.resetPaginationFn = option.resetPagination;
            this.refPagination = option.pagination;
        }
    }
    mode;
    // store mode
    store;
    // ref mode
    list;
    loadFn;
    resetPaginationFn;
    refPagination;
    log;
    isShowRecordsByInitialize;
    // 初期化
    async initialize() {
        if (this.mode === "store") {
            extend(true, this.store.condition, this.store.storedCondition);
            if (this.store.isFind) {
                await this.updateStore();
                return;
            }
            this.store.resetPagination();
            if (this.isShowRecordsByInitialize) {
                await this.updateStore();
            }
        }
        else {
            this.resetPaginationFn?.();
            await this.updateRef();
        }
    }
    // ページング
    async paging(requestData) {
        if (this.mode === "store") {
            this.store.condition.copyFrom(this.store.storedCondition);
            this.store.pagination.copyFrom(requestData);
            await this.updateStore();
            this.store.conditionValid.reset();
            return;
        }
        if (this.mode === "ref") {
            if (requestData) {
                this.refPagination.value.copyFrom(requestData);
            }
            await this.updateRef();
        }
    }
    // 検索
    async search() {
        if (this.mode === "store") {
            if (this.store.conditionValid.error) {
                return;
            }
            this.store.pagination.resetPage();
            this.store.setCondition(this.store.condition);
            await this.updateStore();
        }
        else {
            await this.updateRef();
        }
    }
    // store更新
    async updateStore() {
        try {
            await this.store.load();
        }
        catch (ex) {
            if (ex.status === 401) {
                throw ex;
            }
            else {
                await MsgBox.error(ex.data?.errorMessage ?? "エラーが発生しました");
                this.log.error("find", ex);
            }
        }
        finally {
            this.store.isFind = true;
        }
    }
    // ref更新
    async updateRef() {
        try {
            await this.loadFn();
        }
        catch (ex) {
            await MsgBox.error(ex?.message ?? "エラーが発生しました");
            this.log.error("find", ex);
        }
    }
}
